<template>
    <v-container fluid class="root-step-container">
        <h2 class="text-h5 mb-4">{{ $t("risk-aversion.form4.title") }}</h2>
        <EqsRadio
            :value.sync="formData.p4q1"
            row
            class="mb-2"
            v-bind="{
                label: labelQ1,
                ...schemaDouble.p4q1
            }"
        />
        <EqsRadio
            :value.sync="formData.p4q2"
            row
            class="mb-2"
            v-bind="{
                label: labelQ2,
                ...schemaDouble.p4q2
            }"
        />
        <EqsRadio
            :value.sync="formData.p4q3"
            row
            class="mb-2"
            v-bind="{
                label: labelQ3,
                ...schemaDouble.p4q3
            }"
        />
        <v-spacer />
        <EqsCheckbox
            :value.sync="formData.confirm_infos_reliable"
            class="font-weight-bold mt-4 mb-4"
            v-bind="{
                ...schemaDouble.confirm_infos_reliable
            }"
        >
            <template #label>
                {{ $t("risk-aversion.form4.confirm-reliable") }}
            </template>
        </EqsCheckbox>
    </v-container>
</template>

<script>
import { formMixin } from "@equisafe-ui-vue/src/mixins/formMixin";

export default {
    name: "Form4",
    mixins: [formMixin],
    props: {
        loading: {
            type: Boolean,
            required: true
        },
        isCompany: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {};
    },
    computed: {
        labelQ1() {
            return this.isCompany
                ? this.$t("risk-aversion.form4.q1-company")
                : this.$t("risk-aversion.form4.q1-individual");
        },
        labelQ2() {
            return this.isCompany
                ? this.$t("risk-aversion.form4.q2-company")
                : this.$t("risk-aversion.form4.q2-individual");
        },
        labelQ3() {
            return this.isCompany
                ? this.$t("risk-aversion.form4.q3-company")
                : this.$t("risk-aversion.form4.q3-individual");
        }
    }
};
</script>

<style lang="scss" scoped></style>
